// Polyfill stable language features.
// It uses @babel/preset-env and browserslist
// to only include the polyfills necessary for the target browsers.
import 'regenerator-runtime/runtime';
import 'raf/polyfill';
